import React, { Component } from 'react';
import { Text, View, Image, Button} from 'react-native';
import ApplicationStyles from './ApplicationStyles';
import {UserSession,AppConfig} from 'blockstack';
import Signin from './Signin.js';
import Profile from './Profile';
const appConfig = new AppConfig()
const userSession = new UserSession({ appConfig: appConfig })

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        if (userSession.isSignInPending()) {
            userSession.handlePendingSignIn().then((userData) => {
              window.history.replaceState({}, document.title, "/")
              this.setState({ userData: userData})
            });
        }
    }

    handleSignIn(e) {
        e.preventDefault();
        userSession.redirectToSignIn();
    }
    
    handleSignOut(e) {
        e.preventDefault();
        userSession.signUserOut("https://browser.blockstack.org/account/delete");
    }

  
    render() {
        return (
            <View style={ApplicationStyles.main1Container}>
                { !userSession.isUserSignedIn() ?
                    <Button title='Login' onPress={ this.handleSignIn } />
                    : <Button title='Logout' onPress={ this.handleSignOut } />
                }
            </View>    
            
            );
        }
    }

    export default Header;